import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import { AxiosPromise } from 'axios';
import DashboardLayout from '../layouts/DashboardLayout';
import SearchPanel from '../molecules/SearchPanel';

import {
  getSearchCategoriesList,
  SearchTypeList,
} from '../api/search';
import ButtonsResultsPanelInspector from '../organisms/Search/ButtonResultsPanelInspector';
import SearchTableInspector from '../organisms/Search/SearchTableInspector';
import { setSearchToken } from '../redux/slices/filterSlice';

const SearchPageInspector = () => {
  const [searchValue, setSearchValue] = React.useState<
    SearchTypeList | {}
  >({});
  const dispatch = useDispatch();
  const [
    actualEndpoint,
    setActualEndpoint,
  ] = React.useState<Promise<AxiosPromise> | null>(null);
  const [searchKey, setSearchKey] = React.useState('');
  const [activeTabName, setActiveTabName] = React.useState(
    'all',
  );

  const [dates, setDates] = React.useState(
    {} as { fromDate: Date; toDate: Date },
  );

  const searchData = value => {
    dispatch(setSearchToken(value));
    setSearchKey(value);
    getSearchCategoriesList({ search: value, activity: 7 }).then(
      response => {
        setSearchValue(response.data);
      },
    );
  };

  const setEndpoint = fn => {
    setActualEndpoint(() => fn);
  };

  return (
    <DashboardLayout>
      <Page>
        <Card>
          <StyledSearchPanel setSearchValue={searchData} />
          <ButtonWrapper>
            <ButtonsResultsPanelInspector
              searchValuesData={searchValue}
              setEndpoint={setEndpoint}
              setActiveTabName={setActiveTabName}
              setDates={setDates}
            />
          </ButtonWrapper>
        </Card>
        {actualEndpoint && (
          <Card>
            <SearchTableInspector
              searchKey={searchKey}
              activeTabName={activeTabName}
              actualEndpoint={actualEndpoint}
              dates={dates}
              setDates={setDates}
            />
          </Card>
        )}
      </Page>
    </DashboardLayout>
  );
};

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const Page = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px 16px 0;
  background: var(--defaultBackground);
  font-family: ${FONT_STACK};

  @media only screen and (max-width: 840px) {
    padding: 12px 12px 0;
  }

  @media only screen and (max-width: 540px) {
    padding: 10px 10px 0;
  }
`;

const Card = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: var(--shadow-xs);
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: ${FONT_STACK};

  @media only screen and (max-width: 840px) {
    padding: 14px;
    margin-bottom: 12px;
  }

  @media only screen and (max-width: 540px) {
    padding: 10px;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;

  @media only screen and (max-width: 840px) {
    width: 100% !important;
    button {
      width: 100% !important;
    }
  }
`;

const StyledSearchPanel = styled(SearchPanel)`
  width: 70%;
  height: 50px;
  font-size: 18px;

  @media only screen and (max-width: 840px) {
    width: 100%;
  }
`;

export default SearchPageInspector;
